import axios, { getData } from 'lib/axios'

// get employee staffs at main page
export const getDashboardRequest = async () => {
  return axios.get('/dashboard/request-summary').then(getData)
}

export const getDashboardApprovals = async () => {
  return await axios.get('/approvals').then(getData)
}

export const getLeaveRequestById = async (id) => {
  return await axios.get(`/leave-request/${id}`).then(getData)
}

export const getCalendarToday = async () => {
  return await axios.get('/big-calendar?day=today').then(getData)
  // return await axios.get('/big-calendar?year=2025&month=4').then(getData)
}

export const getLeaveBalance = async () => {
  return await axios.get('/entitlement').then(getData)
}

export const putLeaveRequest = async (id, payload) => {
  return await axios.put(`/leave-approval/${id}`, payload).then(getData)
}

export const postClaimRequest = async (id, payload) => {
  return axios.post(`/approvals/reports/${id}`, payload).then(getData)
}

export const getAnnouncements = async () => {
  return await axios.get('/announcements').then(getData)
}
